import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Option } from '../../../shared/components/dropdown/dropdown.component';

@Component({
  selector: 'py-country-phone-input',
  templateUrl: './country-phone-input.component.html',
  styleUrls: ['./country-phone-input.component.scss'],
  standalone: false,
})
export class CountryPhoneInputComponent implements OnInit {
  searchText = '';

  @Input() group: FormGroup;
  @Input() labelText: string;
  @Input() phonePlaceholderText: string;
  @Input() phoneCodes: Option[] = [];

  ngOnInit(): void {
    if (this.phoneCodes?.length && !this.group?.get('countryPhoneCode')?.value) {
      this.group?.get('countryPhoneCode')?.setValue(this.phoneCodes[0].value);
    }
  }

  onResetValue(): void {
    this.group.get('phone').setValue('');
    this.group.get('phone').updateValueAndValidity();
    this.group.get('phone').markAsDirty();
  }

  onSearch(searchText: string): void {
    this.searchText = searchText;
  }
}
